import * as React from "react"
import { formatPercentage } from "@ui-seeker/utils/"

import { CategoryText } from "../@components"
import { adminScrapingDataReviewPercentageData } from "../../../@signals"


// La celda dice **si hay** descripción, no cuál es: el texto ya no viaja con la tabla —pesaba
// 2,39 MB en un site de 1.266 productos— y llega en `/show-details` al abrir el drawer. Lo que sí
// viaja es `hasDescription`, calculado en SQL sobre `DIPI_PRODUCT_PAGE_DETAILS`
// (`description IS NOT NULL AND description <> ''`), que es de donde sale también el porcentaje de
// la cabecera.
export default function descriptionColumn() {
	return {
		name: "hasDescription",
		label: `Description (${formatPercentage(adminScrapingDataReviewPercentageData.value["percentageDescription"], { decimals: 2 })})`,
		options: {
			display: false,
			setCellHeaderProps: () => ({
                sx: {
                    textAlign: "center",
                    minWidth: 80,
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			setCellProps: () => ({
                sx: {
                    textAlign: "center",
                    borderRight: "1px solid",
                    borderColor: "divider"
                }
            }),
			filterType: "checkbox",
			customBodyRender: value => <CategoryText
				label={value ? "yes" : "no"}
				color={value ? "success" : "error"}
			/>
		}
	}
}